import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DialogService, DynamicDialogConfig } from "primeng/dynamicdialog";
import { SGAddFineComponent } from "../sgadd-fine/sgadd-fine.component";

@Component({
	selector: "app-sgadd-fine-warning",
	templateUrl: "./sgadd-fine-warning.component.html",
	styleUrls: ["./sgadd-fine-warning.component.css"],
})
export class SGAddFineWarningComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogService: DialogService, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		//Load data from parent
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
	}

	///////////////////////
	// Data
	///////////////////////
	user: any;
	SchoolID: any;
	SelectedGroup: any;
	///////////////////////

	///////////////////////
	// Buttons
	///////////////////////
	onOk() {
		this.ref.close(1);

		var ref = this.dialogService.open(SGAddFineComponent, {
			header: "Add Fine Group Action",
			width: "fit-content",
			data: {
				user: this.user,
				SchoolID: this.SchoolID,
				SelectedGroup: this.SelectedGroup,
			},
		});
		ref.onClose.subscribe((response) => {
			this.ref.close(1);
		});
	}
	onCancel() {
		this.ref.close(0);
	}
}
